<template>
  <div id="phzb-detail">
    <div class="search1">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item><img style="width:100%;" src="../../assets/search1.jpg"/></van-swipe-item>
        <van-swipe-item><img style="width:100%;" src="../../assets/search2.jpg"/></van-swipe-item>
      </van-swipe>
    </div>
    <div class="txt">
      <p class="title">陶瓷盆花(1年)</p>
      <p class="price">¥399</p>
    </div>
    <div class="con">
      <p>商品品种</p>
      <section class="red">陶瓷盆花</section>
      <div class="clear"></div>
    </div>
    <div class="txt bd">
      <p class="title1">商品介绍</p>
      <p class="detail">
        组合花卉盆景
        整体风格，现代大气，色彩丰富。盆器选用江西景德镇瓷盆。图案为牡丹诗词，高贵大方。盆高：宽：盆内配以花型各异，花期交错的各类温室类，宿根类，草花类等鲜艳品种。
        图片仅供参考，以现场实物为准。
      </p>
    </div>
    <div class="submit">
      <div @click="show = true">加入订单</div>
    </div>
    <van-action-sheet v-model="show" title="标题">
      <div class="content2">
        <div id="opener">
          <img src="" class="quxiao" />
          <dl>
            <dt>
              <img src="../../assets/search1.jpg" />
            </dt>
            <dd>
              <p class="title">陶瓷盆花(1年)</p>
              <p class="price">¥399</p>
            </dd>
          </dl>
          <div class="clear"></div>
          <div class="s1">
            <p>品种</p>
            <section class="red">陶瓷盆花</section>
            <div class="clear"></div>
          </div>
          <div class="count">
            <p>数量</p>
            <input type="button" value="-" class="btn1" />
            <input type="txt" class="number" />
            <input type="button" value="+" class="btn2" />
          </div>
          <div class="c1" style="height: 2.5rem;"></div>
          <button
            @click="goto"
            class="mint-button cart-btn mint-button--default mint-button--normal"
          >
            <!---->
            <label class="mint-button-txt">确定</label>
          </button>
        </div>
      </div>
    </van-action-sheet>

    <div class="clear-foot"></div>
  </div>
</template>

<script>
export default {
  name: 'penhuazubaiDetail',
  data() {
    return {
      show: false,
    }
  },
  computed: {},
  created() {},
  methods: {
    goto() {
      this.$router.push({ path: '/shopphzbcart' })
    },
  },
  watch: {},
}
</script>
<style>
#phzb-detail {
  background: #fff;
  font-size: 1.4rem;
}
#phzb-detail .txt {
  txt-align: center;
  padding: 2.8rem 2rem 2.5rem;
}
#phzb-detail .txt .title {
  height: 2.5rem;
  font-size: 1.8rem;
  color: #323232;
}
#phzb-detail .txt .price {
  height: 2.8rem;
  font-size: 2rem;
  margin-top: 1.1rem;
  color: #15a892;
}
.con {
  padding: 0 0.8rem;
  margin: 1rem 0;
}
.con p {
  color: #323232;
}
.con section {
  width: 10rem;
  line-height: 3.6rem;
  float: left;
  color: #999;
  txt-align: center;
  background: #eee;
  margin: 0.7rem 1.55rem 0.7rem 0;
}

.red {
  color: #fff !important;
  background-color: #15a892 !important;
}
.clear {
  clear: both;
}
.clear {
  zoom: 1;
}
.clear:after {
  content: '';
  display: block;
  clear: both;
}
#phzb-detail .txt {
  txt-align: center;
  padding: 2.8rem 2rem 2.5rem;
}

#phzb-detail .bd {
  border-bottom: 1px solid #ccc;
}
#phzb-detail .txt .title1 {
  margin: 2.6px 0 1.3rem;
  line-height: 2rem;
  font-weight: 700;
  display: inline-block;
}

#phzb-detail .txt .title1:after,
#phzb-detail .txt .title1:before {
  content: '';
  display: inline-block;
  width: 2rem;
  height: 1px;
  border-top: 1px solid #008a3f;
  margin-right: 1.57rem;
  margin-bottom: 0.4rem;
}
#phzb-detail .txt .title1:after {
  margin-right: 0;
  margin-left: 1.57rem;
}

#phzb-detail .txt .title1:after,
#phzb-detail .txt .title1:before {
  content: '';
  display: inline-block;
  width: 2rem;
  height: 1px;
  border-top: 1px solid #008a3f;
  margin-right: 1.57rem;
  margin-bottom: 0.4rem;
}
#phzb-detail .txt .detail {
  line-height: 2.4rem;
  color: #323232;
}
.submit {
  width: 100%;
  height: 4.9rem;
  background-color: #15a892;
  font-size: 1.6rem;
  color: #fff;
  txt-align: center;
  padding-top: 1.5rem;
  position: fixed;
  bottom: 0;
}
.submit div {
  color: #fff;
  text-align: center;
}
#opener {
  width: 100%;
  box-sizing: border-box;
  font-size: 1.4rem;
  position: relative;
  height: 32rem;
  padding-top: 1rem;
  padding-left: 1rem;
}
#opener .quxiao {
  position: absolute;
  top: 1.3rem;
  right: 1.7rem;
}
#opener dl {
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
  display: flex;
  padding: 0.8rem;
}
#opener dl dt img {
  width: 7rem;
  height: 7rem;
}
#opener dl dd {
  padding: 0 1.5rem;
}
#opener dl dd .title {
  padding-top: 0.75rem;
  color: #323232;
}

#opener dl dd .price {
  padding: 1rem 0;
  color: #15a892;
  font-weight: bolder;
}
#opener .s1 {
  padding: 0 0.8rem;
  margin: 1rem 0;
}
#opener .s1 p {
  color: #323232;
}
#opener .s1 section {
  width: 10rem;
  line-height: 3.6rem;
  float: left;
  color: #999;
  txt-align: center;
  background: #eee;
  margin: 0.7rem 1.55rem 0.7rem 0;
  text-align: center;
}

.red {
  color: #fff !important;
  background-color: #15a892 !important;
}
#opener .count {
  padding: 0 0.8rem;
  margin: 2.2rem 0 3rem;
  display: flex;
  line-height: 3rem;
}
#opener .count p {
  margin-right: 1.4rem;
}
#opener .count .btn1,
#opener .count .btn2 {
  width: 4.2rem;
  background: transparent;
  border: 1px solid #eee;
}
input,
input[type='button'],
input[type='reset'],
input[type='search'],
input[type='submit'],
txtarea {
  -webkit-appearance: none;
}
#opener .count .number {
  width: 6.4rem;
  txt-align: center;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
#opener .count .btn1,
#opener .count .btn2 {
  width: 4.2rem;
  background: transparent;
  border: 1px solid #eee;
}
#opener .cart-btn {
  width: 100%;
  height: 5rem;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #15a892;
  color: #fff;
}
.mint-button--normal,
.mint-button--small {
  display: inline-block;
  padding: 0 12px;
}
.mint-button--default {
  color: #656b79;
  background-color: #f6f8fa;
  box-shadow: 0 0 1px #b8bbbf;
}
.mint-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 4px;
  border: 0;
  box-sizing: border-box;
  color: inherit;
  display: block;
  font-size: 18px;
  height: 41px;
  outline: 0;
  overflow: hidden;
  position: relative;
  txt-align: center;
}
.clear-foot {
  clear: both;
  height: 5rem;
}
</style>
